import { render, staticRenderFns } from "./DatasetHistory.vue?vue&type=template&id=65f45a05&"
import script from "./DatasetHistory.vue?vue&type=script&lang=js&"
export * from "./DatasetHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports